import Vue from 'vue'
import VueRouter from 'vue-router'
const Index = () => import(/* webpackPrefetch: false */ '@/views/Index.vue')
const SigninPage = () => import(/* webpackPrefetch: false */ '@/views/login/SignIn.vue')
const ForgotPasswordPage = () => import(/* webpackPrefetch: false */ '@/views/login/ForgotPassword.vue')
const CodePage = () => import(/* webpackPrefetch: false */ '@/views/login/Code.vue')
const Register = () => import(/* webpackPrefetch: false */ '@/views/register/index.vue')
const FranchisePaymentGateway = () => import(/* webpackPrefetch: false */ '@/views/franchiseManagement/FranchisePaymentGateway.vue')

import userRoutes from './users';
import profileRoutes from './profiles';
import settingRoutes from './settings';
import cpConfigurationRoutes from './cpconfiguration';
import cpSettingRoutes from './captiveportalsetting';
import logRoutes from './log';
import monitoringRoutes from './monitoring';
import billingRoutes from './billing';
import reportRoutes from './reporting';
import accountSettingRoutes from './accountsetting';
import adminRoutes from './admins';
import tasksRoutes from './tasks';
import externalIntegrationRoutes from './externalintegration';
import paymentCollectionRoutes from './paymentCollection';
import dashboardRoutes from './dashboard';
import accesspointsRoutes from './accesspoints';
import announcementsRoutes from './announcements';
import leadsRoutes from './leads';
import inventoryRoutes from './inventory';
import franchiseManagementRoutes from './franchiseManagement';
import helpdeskRoutes from './helpdesk';
import iptvRoutes from './iptv';
import voicephoneRoutes from './voicephone';
import licenseRoutes from './license';
import lockscreenRoutes from './lockscreen';
import analytics from './analytics';
import networksettingsRoutes from './networksettings';
import networkdiagnosticsRoutes from './networkdiagnostics';
import systemtoolsRoutes from './systemtools';
import pinBillingRoutes from './pinbilling';
import overviewRoutes from './overview';
import discountRoutes from './discount';
import paymentRoutes from './payment';
import registerRoutes from './register';
import statusRoutes from './status';
import {
  store
} from '@/store/store';
import axios from "@/api/index";
//const Index = () => System.import('@/views/Index.vue')
//const ForgotPasswordPage = () => System.import('@/views/login/ForgotPassword.vue')
//const CodePage = () => System.import('@/views/login/Code.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/p/:id/:token',
    component: FranchisePaymentGateway,
  },
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SigninPage,
    meta: {
      title: "Login"
    },
    beforeEnter(to, from, next) {
      if (localStorage.getItem('token')) {
        window.location.href = "/dashboard";
      } else {
        next()
      }
    }
  },
  {
    path: '/reset_password',
    component: ForgotPasswordPage
  },
  {
    path: '/code/:inviteCode',
    component: CodePage
  },
  {
    path: '/register',
    component: Register,
    meta: {
      title: "Register"
    }
  },
  userRoutes,
  profileRoutes,
  settingRoutes,
  logRoutes,
  cpConfigurationRoutes,
  monitoringRoutes,
  billingRoutes,
  reportRoutes,
  adminRoutes,
  accountSettingRoutes,
  tasksRoutes,
  cpSettingRoutes,
  externalIntegrationRoutes,
  dashboardRoutes,
  paymentCollectionRoutes,
  accesspointsRoutes,
  announcementsRoutes,
  leadsRoutes,
  inventoryRoutes,
  franchiseManagementRoutes,
  helpdeskRoutes,
  iptvRoutes,
  voicephoneRoutes,
  licenseRoutes,
  lockscreenRoutes,
  analytics,
  networksettingsRoutes,
  networkdiagnosticsRoutes,
  systemtoolsRoutes,
  pinBillingRoutes,
  discountRoutes,
  overviewRoutes,
  paymentRoutes,
  registerRoutes,
  statusRoutes,
  {
    path: '*',
    component: SigninPage,
    beforeEnter(to, from, next) {
      if (localStorage.getItem('token')) {
        window.location.href = "/dashboard";
      } else {
        next()
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  next()
  if (to.meta.title != undefined && store.state.layout.headerDetails.meta_header != undefined) {
    document.title = store.state.layout.headerDetails.meta_header.title + " : " + to.meta.title
  } else {
    axios
      .get("/login/get_signin_logo")
      .then((response) => {
        if (response.data.meta_data != undefined) {
          document.title = response.data.meta_data.title + " : " + to.meta.title
        }
      })
      .catch((error) => console.log(error));
  }
})



export default router
